function importErrorDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/import/import-error/import-error-dialog.html'
  }
}

export { importErrorDialog }
